import { useAuthentication } from "@tecnobit-srl/authentication";
import { useNavigateTo } from "@tecnobit-srl/router";
import { useCallback, useMemo } from "react";
//#region src/use-buy-api.ts
function useBuyApi({ code, quantity = 1, months, redirectUrl, previousUrl, defaultUrl, currencyCode, requireAuth = false }) {
	const { user, login, getLoginUrl } = useAuthentication();
	const navigateTo = useNavigateTo();
	const needsLogin = requireAuth && !user;
	const url = useMemo(() => {
		if (needsLogin) return getLoginUrl(redirectUrl);
		return code ? `/buy?${redirectUrl ? `redirect=${encodeURIComponent(redirectUrl)}&` : ""}${previousUrl ? `previous_url=${encodeURIComponent(previousUrl)}&` : ""}p=[${encodeURIComponent(JSON.stringify({
			code,
			quantity,
			months,
			currency: currencyCode
		}))}]` : defaultUrl;
	}, [
		code,
		needsLogin,
		getLoginUrl,
		redirectUrl,
		previousUrl,
		quantity,
		months,
		currencyCode,
		defaultUrl
	]);
	const callback = useCallback(async () => {
		if (needsLogin) {
			await login();
			return;
		}
		if (url) await navigateTo(url);
	}, [
		needsLogin,
		login,
		navigateTo,
		url
	]);
	return useMemo(() => ({
		callback,
		url
	}), [callback, url]);
}
//#endregion
export { useBuyApi };
